import { NativeError, RuntimeError } from '@belimo-retrofit-portal/logic';
import { SagaIterator } from 'redux-saga';
import { decodeOrThrow } from 'src/io/utils/decodeOrThrow';
import { makeRestRequest } from 'src/modules/api/sagas/utils/makeRestRequest';
import { PROJECT_SETTINGS } from 'src/modules/common/codecs/ProjectSettings';
import { Project } from 'src/modules/common/types/Project';
import { ProjectSettings } from 'src/modules/common/types/ProjectSettings';
import { call } from 'typed-redux-saga';

export function* loadProjectSettings(
  project: Project,
): SagaIterator<ProjectSettings> {
  try {
    const { content } = yield* call(makeRestRequest, 'GET', `/projects/${encodeURIComponent(project.id)}/settings`);
    return decodeOrThrow(PROJECT_SETTINGS, content);
  } catch (error) {
    throw new RuntimeError('Could not load project settings', { project }, NativeError.wrap(error));
  }
}
